export const quotaIndustry = {
  province_list: {
    100000: '钢铁行业',
    110000: '发电行业',
    120000: '航空行业',
    130000: '化工行业',
    140000: '建材行业',
    150000: '石化行业',
    160000: '有色金属行业',
    170000: '造纸行业',
    180000: '其他行业'
  }
}
